<template>
    <div class="container-fluid mt-5">
        <h1 class="text-uppercase">{{ title }}</h1>

        <AdsComponent :advertisements="advertisements" />
    </div>
</template>

<script>
    import AdsComponent from "../../components/AdsComponent";
    export default {
        name: "Escort",
        components: {AdsComponent},
        metaInfo() {
            return {
                title: this.title.charAt(0).toUpperCase() + this.title.slice(1),
            }
        },
        data() {
            return {
                advertisements: [],
                title: this.$route.params.slug.split('-').join(' ')
            }
        },
        created() {
            window.scrollTo(0,0);
            this.fetchData()
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements/top`)
                    .then((response) => {
                        this.advertisements = response.data;
                    })
            },
        },
        watch: {
           '$route.params.slug': function () {
                window.scrollTo(0,0);
                this.title = this.$route.params.slug.split('-').join(' ');
            }
        }
    }
</script>

<style scoped>

</style>
